<template>
  <confirm-modal
    ref="modal"
    title="Удаление типа отпуска"
    confirm="Удалить"
    reset="Отменить"
    mode="danger"
    @confirm="confirm"
  >
    <span v-if="type">
      Тип отпуска <b>{{ type.name }}</b> будет удалён без возможности восстановления.
    </span>
  </confirm-modal>
</template>

<script>
import ConfirmModal from "@/components/modals/confirm-modal";

export default {
  name: "remove-type-modal",
  components: { ConfirmModal },
  data() {
    return {
      type: null,
      name: null,
    };
  },
  methods: {
    open(type) {
      this.type = type;
      this.name = type.name;
      console.log("optn", type);
      this.$refs.modal.open();
    },
    confirm() {
      if (this.type) {
        this.$emit("remove", this.type);
      }
    },
  },
};
</script>
